module.exports = __webpack_public_path__ + "img/female-smart-phone.40d389a4.png";